import { render, staticRenderFns } from "./AddStockMovementComponent.vue?vue&type=template&id=2608e866"
import script from "./AddStockMovementComponent.vue?vue&type=script&lang=js"
export * from "./AddStockMovementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports